import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { retrieveTeacherStudents } from "./retrieve-students";
import type { TeacherStudentListElement } from "@shared-kernel/application/ports/teacher/teacher-repository";

const initialState: RetrievalState<TeacherStudentListElement[]> = { fetching: "idle", data: [] };

export const retrieveTeacherStudentsReducer = createReducer<RetrievalState<TeacherStudentListElement[]>>(initialState, builder => {
  builder.addCase(retrieveTeacherStudents.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveTeacherStudents.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveTeacherStudents.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
